"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnumValues = exports.getAsEnum = exports.getAsEnumKey = void 0;
/**
 * Convers a string value into an enum value.
 *
 * @param value the string value
 * @param enumObject the enum object
 * @param defaultValue optional default value
 *
 * @author Adam Ayres
 */
function getAsEnum(value, enumObject, defaultValue = null) {
    const enumValue = Object.values(enumObject).find(enumObjectValue => enumObjectValue === value);
    return enumValue !== null && enumValue !== void 0 ? enumValue : defaultValue;
}
exports.getAsEnum = getAsEnum;
function getAsEnumKey(value, enumObject, defaultValue = null) {
    const enumValue = Object.keys(enumObject).find(enumObjectKey => enumObject[enumObjectKey] === value);
    return enumValue !== null && enumValue !== void 0 ? enumValue : defaultValue;
}
exports.getAsEnumKey = getAsEnumKey;
function getEnumValues(enumObject) {
    return Object.values(enumObject).filter(item => {
        return Number.isNaN(Number(item));
    });
}
exports.getEnumValues = getEnumValues;
//# sourceMappingURL=EnumHelper.js.map